import * as React from "react";
import { Box } from "@mui/material";
import { SectionHeaderlessContext } from "../sections/SectionAccordion";

export interface MobileSectionViewProps {
  title: string;
  /** Optional summary — passed through to MobileShell AppBar (not rendered here). */
  trailing?: string;
  /** Color for the trailing summary — passed through (not rendered here). */
  trailingColor?: string;
  onBack: () => void;
  children: React.ReactNode;
}

/**
 * Content wrapper for a single section opened full-width on mobile.
 *
 * This component intentionally has NO title bar of its own.  MobileShell's
 * AppBar already shows the section title, dollar total, and back arrow when
 * `selectedSectionId` is set — adding another header here caused a duplicate
 * "← Notes / ← Notes" row (screenshots confirmed).
 *
 * The only job here is to:
 *  1. Wrap children in SectionHeaderlessContext so SectionAccordion suppresses
 *     its own header when reused inside this view.
 *  2. Add comfortable content padding.
 */
export function MobileSectionView({
  children,
}: MobileSectionViewProps) {
  return (
    <Box sx={{ px: 1, pt: 1 }}>
      <SectionHeaderlessContext.Provider value={true}>
        {children}
      </SectionHeaderlessContext.Provider>
    </Box>
  );
}
